// extracted by mini-css-extract-plugin
export var active = "_az-7";
export var container = "_az-0";
export var evenWidth = "_az-4";
export var large = "_az-5";
export var outlet = "_az-8";
export var slide = "_az-2";
export var small = "_az-6";
export var tab = "_az-3";
export var tabs = "_az-1";